import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import { setCustomComponentPrefix } from '@vonage/vivid-vue';
import { App } from 'vue';
import { createPinia } from 'pinia';
import { BugsnagApiID, BugsnagApiKey, IsBugsnagEnabled } from '@/constants';
import createRouterObject from '@/router';
import createI18nInstance from '@/plugins/i18n';

// eslint-disable-next-line import/prefer-default-export
export async function handleInstance(
  app: App<Element>,
  { locale, routerBase }: { locale: string; routerBase: string }
) {
  if (IsBugsnagEnabled) {
    // init bugsnag
    Bugsnag.start({
      apiKey: BugsnagApiKey,
      plugins: [new BugsnagPluginVue()],
      appVersion: BugsnagApiID,
    });
    // add bugsnag to Vue app
    const bugsnagVue = Bugsnag.getPlugin('vue');
    bugsnagVue?.installVueErrorHandler(app);
  }
  app.use(createPinia());

  const i18nInstance = await createI18nInstance(locale);
  app.use(i18nInstance);

  app.use(createRouterObject(routerBase));
  setCustomComponentPrefix('dev-docs');

  // override warn handler to upgrade some warnings to errors (only applies in dev mode)
  app.config.warnHandler = (msg, instance, trace) => {
    // templates failing to compile breaks the page in the production build so don't let this pass as warning
    if (msg.includes('Template compilation error')) {
      // eslint-disable-next-line no-console
      console.error(msg, instance, trace);
      throw new Error(msg);
    }

    // eslint-disable-next-line no-console
    console.warn(msg, instance, trace);
  };

  // this is needed for the termynal snippets otherwise whitespace inside tags gets removed changing the format
  app.config.compilerOptions.whitespace = 'preserve';
}
